import React, {PropTypes} from "react";
import Modal from "react-bootstrap/lib/Modal";
import axios from "axios";
import toastr from "toastr";

class ModalMultiple extends React.Component {

  constructor() {
    super();
    this.state = {}
  }

  render() {
    console.log(this.props);
    return (
      <Modal
        bsSize="small"
        show={this.props.open} onHide={this.props.close}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Multiple Full And Final</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>On Confirmation, Full and Final settlement report will be generated & the selected employees will be notified.</p>
          <p>Number of Employees Selected: {this.props.selectedEmployees.length}</p>
          <br/>
          <div>
            <button className="btn btn-default btn-block" onClick={()=> {
              let flag = confirm('Are you Sure?');
              if (flag == true) {
                let request = new Object();
                request.empId = [...this.props.selectedEmployees];
                axios.post(process.env.REQ_URL + "/exit/fullAndFinal", {data: request}, {withCredentials: true , responseType: 'blob', headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                  const link = document.createElement('a');
                  link.href = window.URL.createObjectURL(new Blob([response.data]));
                  link.setAttribute('download', 'Relieving Letter Draft.pdf');
                  document.body.appendChild(link);
                  link.click();
                  link.remove();
                  this.props.close();
                  this.props.refresh();
                  $(".react-bs-select-all").click();
                  toastr.success("Multiple Full And Final Completed");
                }).catch((err)=> {
                  console.log(err);
                  toastr.error("Error Occurred");
                });
              }
            }}>Confirm
            </button>
          </div>
          <br/>
          <button
            className="btn btn-default btn-block"
            onClick={()=> {
              this.props.close();
            }}
          >Cancel
          </button>
        </Modal.Body>
      </Modal>
    );
  }
}

ModalMultiple.propTypes = {};

export default ModalMultiple;



/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/ExitFinal/ModalMultipleFullFinal.js
 **/